import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
const Payroll = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div class="row mx-0 payroll-page">
              <div class="shadowclass">
                <div class="col-12">
                  <div class="counts">
                    <h4 class="event-alert">New Payroll</h4>
                    <div class="row justify-content-start">
                      <div class="col-sm-6 col-lg-4 col-12 search-div d-flex flex-wrap pb-3 pb-sm-0">
                        <label className="label">
                          <strong>New Payroll Period</strong>
                        </label>
                        <div class="select-div col-lg-8 col-md-7 col-12">
                          <select class="select w-100">
                            <option>Select Payroll Period</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-6 col-lg-4 col-12 search-div d-flex flex-wrap px-lg-4 pb-3 pb-sm-0">
                        <label className="label">
                          <strong>Status</strong>
                        </label>
                        <div class="select-div col-lg-8 col-md-7 col-12">
                          <select class="select w-100">
                            <option>Select Payroll Period</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-6 col-lg-4 col-12 search-div d-flex flex-wrap justify-content-start">
                        <label className="label">
                          <strong>Period Status</strong>
                        </label>
                        <a class="new-sub">Initial</a>
                      </div>
                    </div>

                    <div
                      className="accordion inv-accordion Account_list_table"
                      id="accordionPanelsStayOpenExample"
                    >
                      <div className="accordion-item">
                        <div
                          id="panelsStayOpen-collapseNine"
                          className="accordion-collapse collapse show"
                          aria-labelledby="panelsStayOpen-headingNine"
                        >
                          <div className="">
                            <div className="row mx-0">
                              <div className="container px-0">
                                <div className="shadowclass mt-0">
                                  <div className="table-responsive">
                                    <table className="accordion_table table payroll_table payroll-table">
                                      <thead>
                                        <tr>
                                          <th
                                            class="text-left sm-td"
                                            valign="bottom"
                                          >
                                            <span class="checkbox">
                                              <input
                                                type="checkbox"
                                                id="PayrollIndividualSelectAll"
                                              />
                                              <label for="PayrollIndividualSelectAll"></label>
                                            </span>
                                          </th>
                                          <th class="text-left mw_160">Name</th>
                                          <th
                                            class="text-left"
                                            width=""
                                            valign="bottom"
                                          >
                                            Status
                                          </th>
                                          <th width="" valign="bottom">
                                            Reg. Wages
                                            <br />
                                            <i>(Mom%)</i>
                                          </th>
                                          <th width="" valign="bottom">
                                            OT Wages
                                            <br />
                                            <i>(Mom%)</i>
                                          </th>
                                          <th width="" valign="bottom">
                                            Total Wages
                                            <br />
                                            <i>(Mom%)</i>
                                          </th>
                                          <th width="">
                                            Employee <br />
                                            Var. Pay
                                          </th>
                                          <th width="">
                                            Tips Paid <br /> Out
                                          </th>
                                          <th width="">Leave Pay </th>
                                          <th width="">
                                            Employee <br /> CPF
                                          </th>
                                          <th width="">MBMF </th>
                                          <th width="">SINDA </th>
                                          <th width="">CDAC </th>
                                          <th width="">ECF </th>
                                          <th width="" valign="bottom">
                                            Net Pay
                                          </th>
                                          <th width="">
                                            Employer <br /> CPF
                                          </th>
                                          <th width="">SDL </th>
                                          <th width="">FWL </th>
                                          <th width="" valign="bottom">
                                            Total Cost
                                          </th>
                                          <th width="" valign="bottom">
                                            Ordinary <br />
                                            Wages(OW)
                                          </th>
                                          <th width="" valign="bottom">
                                            Additional <br />
                                            Wages(AW)
                                          </th>
                                          <th width="" valign="bottom">
                                            Annual AW <br />
                                            Ceiling
                                          </th>
                                          <th width="" valign="bottom">
                                            AW Used
                                          </th>
                                          <th width="" valign="bottom">
                                            AW Remaining
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr class="main-tr bg-gry">
                                          <td
                                            align="center"
                                            className="text-left sm-td"
                                          >
                                            <div>
                                              <span class="checkbox">
                                                <input
                                                  type="checkbox"
                                                  name="data[PayrollIndividual][0][select_employee]"
                                                  class="employeeCheckbox"
                                                  data-eid="619"
                                                  value="1"
                                                  id="test2"
                                                />
                                              </span>

                                              <div class="dropdown-sec">
                                                <button
                                                  className="dropdown-green collapsed"
                                                  type="button"
                                                  data-bs-toggle="collapse"
                                                  data-bs-target="#flush-collapseOne"
                                                  aria-expanded="false"
                                                  aria-controls="flush-collapseOne"
                                                ></button>
                                              </div>
                                            </div>
                                          </td>
                                          <td className="text-left">
                                            <strong>Revolver</strong>
                                          </td>
                                          <td className="text-left"> </td>
                                          <td>
                                            <span
                                              class="total_grand_after_adj_pay_dummy_span bold"
                                              regwagesavg="0"
                                            >
                                              $0.00
                                            </span>
                                            <span class="arrow_symbol clear arrow_up">
                                              0%
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_grand_after_adj_ot_dummy_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_total_pay_dummy_span bold">
                                              $0.00
                                            </span>
                                            <span class="arrow_symbol clear arrow_up">
                                              0%
                                            </span>
                                          </td>
                                          <td>
                                            <span class="grand_emp_var_pay_span bold">
                                              $0.00
                                            </span>
                                          </td>

                                          <td>
                                            <span class="total_tips_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_leave_pay_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span class="grand_employee_contribution_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_mbmf_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_sinda_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_cdac_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_ecf_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span class="grand_net_pay_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span class="grand_employer_contribution_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_sdl_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_fwl_span bold">
                                              $0.00
                                            </span>
                                          </td>

                                          <td>
                                            <span class="grand_total_cost_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_ordinary_wage_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_additional_wage_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_annual_aw_ceiling_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_aw_used_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_aw_remaining_span bold">
                                              $0.00
                                            </span>
                                          </td>
                                        </tr>


                                        <tr
                                          id="flush-collapseOne"
                                          className="accordion-collapse collapse"
                                          aria-labelledby="flush-headingOne"
                                          data-bs-parent="#accordionFlushExample"
                                        >
                                          <td>
                                            <div className="d-flex align-items-center">
                                              <span class="checkbox">
                                                <input
                                                  type="checkbox"
                                                  name="data[PayrollIndividual][0][select_employee]"
                                                  class="employeeCheckbox"
                                                  data-eid="883"
                                                  value="1"
                                                  id="PayrollIndividual0SelectEmployee"
                                                />
                                                <label for="PayrollIndividual0SelectEmployee"></label>{" "}
                                              </span>
                                              <a>
                                                <i class="edit-icon"></i>
                                              </a>
                                              <div class="imagediv">
                                                <img
                                                  src="/img/no-image-found.png"
                                                  id="preview"
                                                  alt="Abhinav"
                                                />{" "}
                                              </div>
                                            </div>
                                          </td>
                                          <td class="text-left">
                                            <span class="first-label">
                                              Abhinav
                                            </span>
                                          </td>
                                          <td class="text-left">Full Time </td>
                                          <td>
                                            $4,000.00{" "}
                                            <span class="arrow_symbol clear arrow_up">
                                              0%
                                            </span>{" "}
                                          </td>
                                          <td>$0.00 </td>
                                          <td>
                                            $4,000.00
                                            <span class="arrow_symbol clear arrow_up">
                                              0%
                                            </span>
                                          </td>
                                          <td class="count-unit">
                                            <span class="dolor-sign">$</span>
                                            <input
                                              name="data[PayrollIndividual][0][emp_var_pay]"
                                              class="negCurrency"
                                              type="text"
                                              id="PayrollIndividual0EmpVarPay"
                                            />{" "}
                                          </td>

                                          {/* <td class="count-unit">$40.00</td>
                                          <td class="count-unit">$40.00</td>
                                          <td class="count-unit">$0.00</td> */}

                                          <td class="count-unit">
                                            <span class="dolor-sign">$</span>
                                            <input
                                              class="negCurrency"
                                              type="text"
                                            />{" "}
                                          </td>
                                          <td class="count-unit">
                                            <span class="dolor-sign">$</span>
                                            <input
                                              class="negCurrency"
                                              type="text"
                                            />{" "}
                                          </td>

                                          <td class="count-unit">
                                            <span class="dolor-sign">$</span>
                                            <input
                                              class="negCurrency"
                                              type="text"
                                            />
                                          </td>
                                          <td class="count-unit">
                                            <span class="dolor-sign">$</span>
                                            <input
                                              class="negCurrency"
                                              type="text"
                                            />
                                          </td>
                                          <td class="count-unit">
                                            <span class="dolor-sign">$</span>
                                            <input
                                              class="negCurrency"
                                              type="text"
                                            />
                                          </td>
                                          <td class="count-unit">
                                            <span class="dolor-sign">$</span>
                                            <input
                                              class="negCurrency"
                                              type="text"
                                            />
                                          </td>
                                          <td class="count-unit">
                                            <span class="dolor-sign">$</span>
                                            <input
                                              class="negCurrency"
                                              type="text"
                                            />
                                          </td>
                                          <td>
                                            <span
                                              class="net_pay_span span_net_pay_emp_883"
                                              employee_id="883"
                                              id="net_pay_span_0"
                                            >
                                              $4,080.00
                                            </span>
                                          </td>
                                          <td class="count-unit">
                                            <span class="dolor-sign">$</span>
                                            <input
                                              class="negCurrency"
                                              type="text"
                                            />
                                          </td>

                                          <td class="count-unit">
                                            <span class="dolor-sign">$</span>
                                            <input
                                              class="negCurrency"
                                              type="text"
                                            />
                                          </td>
                                          <td class="count-unit">
                                            <span class="dolor-sign">$</span>
                                            <input
                                              class="negCurrency"
                                              type="text"
                                            />{" "}
                                          </td>
                                          <td>
                                            <span
                                              class="total_cost_span span_total_cost_emp_883"
                                              id="span_total_cost_0"
                                            >
                                              $4,080.00
                                            </span>
                                          </td>
                                          <td>
                                            <span
                                              class="total_ow_span span_total_ow_emp_883"
                                              id="span_total_ow_0"
                                            >
                                              $4,080.00
                                            </span>
                                          </td>
                                          <td>
                                            <span
                                              class="total_aw_span span_total_aw_emp_883"
                                              id="span_total_aw_0"
                                            >
                                              $0.00
                                            </span>
                                          </td>
                                          <td>
                                            <span
                                              class="total_aw_ceiling"
                                              id="span_aw_ceiling_0"
                                            >
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td class="count-unit">
                                            <span class="dolor-sign">$ </span>
                                            <input
                                              class="negCurrency"
                                              type="text"
                                            />{" "}
                                          </td>
                                          <td>
                                            <span
                                              class="total_aw_remaining"
                                              id="span_aw_remaining_0"
                                            >
                                              $0.00{" "}
                                            </span>
                                          </td>
                                        </tr>


                                        <tr
                                        >
                                          <td className="sm-td"></td>
                                          <td class="total text-left">
                                            <strong>Total</strong>
                                          </td>
                                          <td className="text-left"></td>
                                          <td>
                                            <span
                                              class="total_grand_after_adj_pay_dummy_span bold"
                                              regwagesavg="0"
                                            >
                                              $0.00{" "}
                                            </span>
                                            <span class="arrow_symbol clear arrow_up">
                                              0%
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_grand_after_adj_ot_dummy_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_total_pay_dummy_span bold">
                                              $0.00{" "}
                                            </span>
                                            <span class="arrow_symbol clear arrow_up">
                                              0%
                                            </span>
                                          </td>
                                          <td>
                                            <span class="grand_emp_var_pay_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>

                                          <td>
                                            <span class="total_tips_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_leave_pay_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td>
                                            <span class="grand_employee_contribution_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_mbmf_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_sinda_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_cdac_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_ecf_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td>
                                            <span class="grand_net_pay_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td>
                                            <span class="grand_employer_contribution_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_sdl_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_fwl_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>

                                          <td>
                                            <span class="grand_total_cost_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_ordinary_wage_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_additional_wage_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_annual_aw_ceiling_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_aw_used_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                          <td>
                                            <span class="total_aw_remaining_span bold">
                                              $0.00{" "}
                                            </span>
                                          </td>
                                        </tr>

                                        <tr class="white-bg brdrt">
                                          <td></td>
                                          <td class="total italic text-left">
                                            Other Adjustments
                                          </td>
                                          <td></td>
                                          <td>
                                            <span class="italic">$0.00 </span>
                                          </td>
                                          <td>
                                            <span class="italic">$0.00 </span>
                                          </td>
                                          <td>
                                            <span class="italic">$0.00 </span>
                                          </td>
                                          <td> </td>
                                          <td> </td>
                                          <td> </td>
                                          <td> </td>
                                          <td> </td>
                                          <td> </td>
                                          <td> </td>
                                          <td> </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mx-0">
                <div class="container px-0 d-flex col-12">
                  <div class="btns col-4 d-flex justify-content-end py-4 col-12 payroll_btn_sec">
                    <button id="" className="btn bordered-btn" type="Submit">
                      Run CPF Calc.
                    </button>
                    <button id="" className="btn bordered-btn" type="Submit">
                      Save
                    </button>
                    <button className="btn mx-0" id="" type="Submit">
                      Submit
                    </button>
                    <button id="cancel" className="btn" type="button">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Payroll;
